import React from "react";
import lowCode1 from '../assets/image/lowcode_icons/lowCode1.png';
import lowCode2 from '../assets/image/lowcode_icons/lowCode2.png';
import lowCode3 from '../assets/image/lowcode_icons/lowCode3.png';
import lowCode4 from '../assets/image/lowcode_icons/lowCode4.png';

const LowCode = ({ MarginTop }) => {

    const data = [
        {
            id: "01",
            title: "We Won't Mislead You",
            desc: (
                <>
                    Let's be honest! 'Low code' has become one of those buzzwords that gets thrown around carelessly in our industry. We're not going to do that. The truth is, while our platform offers{" "}
                    <b className="bold_text">virtually infinite configurability</b>
                    {" "}to adapt to your lending products and workflows, we know that every organization has unique requirements that go beyond standard configuration.
                </>
            ),
            iconImage: lowCode1,
            color: "#1ea7ff",
        },
        {
            id: "02",
            title: "When You Need More",
            desc: "There will be times when your specific business needs require custom development. Maybe it's a unique integration, a specialized workflow, or a feature tailored to your market. We get it, and we won't pretend that clicking a few buttons will solve every problem.",
            iconImage: lowCode2,
            color: "#00e7c5",
        },
        {
            id: "03",
            title: "What We Promise Instead",
            desc: "When you need custom features, our agile development process ensures you get them in the shortest time humanly possible. No bloated development cycles. No endless waiting. Just focused, efficient development that delivers what you need, when you need it.",
            iconImage: lowCode3,
            color: "#fdb644",
        },
        {
            id: "04",
            title: "Our Commitment To you",
            desc: (
                <>
                    We'd rather be honest partners who deliver results than make empty promises about {" "}
                    <b className="bold_text">zero code</b>
                    {" "}solutions that fall short when you need them most.
                </>
            ),
            iconImage: lowCode4,
            color: "#6349cd",
        },
    ];

    return (
        <section id="lowcode" style={{ scrollMarginTop: MarginTop }}>
            <div className='home-section our_services_sec'>
                {/* <div className="section-badge">
                    <span className="title-side-line"></span>
                    <h5 className="badge-text">Low Code</h5>
                    <span className="title-side-line"></span>
                </div> */}
                <div className="title-section">
                    <h1 className="head-title">Low Code</h1>
                    <span className="title-under-line"></span>
                    <p className="title-disc">Low code is not about replacing developers. It's about empowering your business to move faster. And when you need more,
                        we're here with the expertise to make it happen.
                    </p>
                </div>
                <div className="trust-timeline">
                    {data.map((item) => (
                        <div className="trust-row" key={item.id}>
                            <div className="trust-icon-wrapper">
                                <div className="trust-icon-card" style={{ "--clr": item.color }}> <img src={item.iconImage} alt="lowcode_icons" /></div>
                            </div>

                            <div className="trust-divider">
                                <span className="trust-dot" style={{ background: item.color, boxShadow: `0 0 18px ${item.color}` }}></span>
                            </div>

                            <div className="trust-content">
                                <div className="trust-number" style={{ color: item.color }}>{item.id}</div>
                                <div className="trust-text">
                                    <h3 className="trust-title">{item.title}</h3>
                                    <span className="trust-title-line" style={{ background: item.color }}></span>
                                    <p className="trust-description">{item.desc}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )

}

export default LowCode;